"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getEducation = function getEducation(education, constants) {
  return education || constants.DEFAULT_VALUE;
  /*
  if (education !== undefined) {
    return education;
  }
  //if (education && constants[`${education.toUpperCase()}_VALUE`]) {
    //return constants[`${education.toUpperCase()}_VALUE`];
  //}
   return constants.DEFAULT_VALUE;
  */
};

var getValue = function getValue(jobEducation, userEducation) {
  var constants = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var userValue = getEducation(userEducation, constants);
  var jobValue = getEducation(jobEducation, constants);
  var value = userValue - jobValue;

  if (value > 0) {
    return constants.GREATER_EDUCATION_BOOST * Math.pow(value, 2);
  } else if (value < 0) {
    return constants.MISSING_EDUCATION_PENALTY * Math.abs(value);
  }

  return 0;
};

exports.default = getValue;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/match/education/getValue.js
// module id = 1312
// module chunks = 0